import styles from './searchBar.module.css';
import { useState } from 'react';

function SearchBar(props) {

  const [searchTerm, setSearchTerm] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchTerm) {
      return;
    }
    props.onSearch(searchTerm);
  };

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

   return (
    <div className={styles.searchBar}>
      <form  className={styles.searchForm} onSubmit={handleSubmit} >
        <input placeholder="Enter A Song, Album, or Artist, press 'Enter' to search." className={styles.input} onChange={handleChange} />
      </form>
    </div>
  );
}

export default SearchBar;
